import React from 'react';
import Lottie from 'react-lottie-player';

import * as loadingAnimation from './loading-animation.json';

const AnimatedLogo = (): React.ReactElement => {
  return <Lottie loop animationData={loadingAnimation} play />;
};

export default AnimatedLogo;
